import { ReactNode } from 'react';
import View from '../view';
import { H1, P, A, Span } from '../text';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import { FelaExtend, ThemedStyleProps } from '../../../types/fela';

type PageProps = {
  children?: ReactNode;
  title?: string;
  linkBack?: (value: number) => void;
  onClickLinkBack?: () => void;
  linkTitle?: string;
  onClickLink?: () => void;
  extend?: FelaExtend;
  linkIcon?: ReactNode;
  linkDisabled?: boolean;
};

const Page = ({
  children,
  title,
  linkBack,
  onClickLinkBack,
  linkTitle,
  onClickLink,
  extend,
  linkIcon = <AddIcon sx={{ width: 16, height: 16, fontSize: 16 }} />,
  linkDisabled,
}: PageProps) => {
  function goBack() {
    linkBack?.(-1);
  }

  const styles = {
    pageCSS: ({ theme: { layout, colors } }: ThemedStyleProps) => ({
      marginTop: `${2 * layout.grid}px`,
      paddingBottom: '18px',
      borderRadius: `${1 * layout.grid}px`,
      width: '100%',
      marginBottom: '18px',
      overflowY: 'visible',
      backgroundColor: colors.offWhite,
      '> h1': {
        marginBottom: 20,
      },
    }),
    linkBack: ({ theme: { colors } }: ThemedStyleProps) => ({
      paddingBottom: '8px',
      backgroundColor: 'rgb(243, 243, 243)',
      position: 'relative',
      '> svg': {
        fontSize: 21,
        position: 'absolute',
        left: -6,
        top: -1,
      },
      '> span': {
        paddingLeft: 17,
      },
    }),
    titleWrapper: ({ theme: { colors, shadowStyle } }: ThemedStyleProps) => ({
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: '#DDDDDD',
      paddingLeft: '26px',
      alignItems: 'center',
      height: '34px',
      '> div': {
        backgroundColor: '#DDDDDD',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: colors.primary,
        cursor: 'pointer',
        '> svg': {
          width: 16,
          height: 16,
          fontSize: 16,
        },
        '> p': {
          color: colors.primary,
          fontFamily: 'Futura',
          fontSize: 16,
        },
      },
      ...shadowStyle,
    }),
    disabled: ({ theme: { colors } }: ThemedStyleProps) => ({
      '> div': {
        '> p': {
          color: colors.disabledGrey,
        },
        cursor: 'default',
      },
    }),
  };

  return (
    <View extend={[styles.pageCSS, extend]}>
      {linkBack && (
        <A
          extend={styles.linkBack}
          onClick={() => {
            goBack();
            onClickLinkBack?.();
          }}
        >
          <ArrowBackIcon />
          <Span>BACK</Span>
        </A>
      )}
      {title ? (
        <View extend={[styles.titleWrapper, linkDisabled ? styles.disabled : undefined]}>
          {<H1 text={title.toUpperCase()} />}
          {linkTitle && (
            <View extend={{ marginLeft: '10px' }} onClick={linkDisabled ? undefined : () => onClickLink?.()}>
              {linkIcon}
              <P noPadding>{linkTitle.toUpperCase()}</P>
            </View>
          )}
        </View>
      ) : null}
      <View style={{ padding: '0 12px' }}>{children}</View>
    </View>
  );
};

export default Page;
